import {IRRIGATIONS} from "../utils/enumItemsUtils";

export type IrrigationDataKeys = keyof IrrigationData;

export interface IrrigationData {
    id: string;
    real_name_irrigation: string;
    type: string;
    on_farm_efficiency_min: number;
    runoff_ratio_irrigation: number;
    min_applied_water: number;
    max_applied_water: number;
    irrigation_criterium_min: number;
    irrigation_default: number;
    desirable_storage: number;
    irrigation_rotation_default: number;
}

export const irrigationDefaults: IrrigationData[] = [
    {
        id: "1",
        real_name_irrigation: "Drip",
        type: "drip",
        on_farm_efficiency_min: 0.9,
        runoff_ratio_irrigation: 0.98,
        min_applied_water: 1,
        max_applied_water: 14,
        irrigation_criterium_min: 0.1,
        irrigation_default: 20,
        desirable_storage: 0.3,
        irrigation_rotation_default: 1,
    },
    {
        id: "2",
        real_name_irrigation: "Sub-Surface Drip",
        type: "sub_surface_drip",
        on_farm_efficiency_min: 0.95,
        runoff_ratio_irrigation: 1,
        min_applied_water: 2,
        max_applied_water: 13,
        irrigation_criterium_min: 0.1,
        irrigation_default: 20,
        desirable_storage: 0.3,
        irrigation_rotation_default: 1,
    },
    {
        id: "3",
        real_name_irrigation: "Sprinkler",
        type: "sprinkler",
        on_farm_efficiency_min: 0.75,
        runoff_ratio_irrigation: 0.85,
        min_applied_water: 2,
        max_applied_water: 45,
        irrigation_criterium_min: 0.1,
        irrigation_default: 30,
        desirable_storage: 0.35,
        irrigation_rotation_default: 2,
    },
    {
        id: "4",
        real_name_irrigation: "Center Pivot",
        type: "center_pivot",
        on_farm_efficiency_min: 0.8,
        runoff_ratio_irrigation: 0.85,
        min_applied_water: 2,
        max_applied_water: 12,
        irrigation_criterium_min: 0.1,
        irrigation_default: 25,
        desirable_storage: 0.35,
        irrigation_rotation_default: 1,
    },
    {
        id: "5",
        real_name_irrigation: "Traveling Gun",
        type: "traveling_gun",
        on_farm_efficiency_min: 0.65,
        runoff_ratio_irrigation: 0.75,
        min_applied_water: 5,
        max_applied_water: 50,
        irrigation_criterium_min: 0.1,
        irrigation_default: 30,
        desirable_storage: 0.7,
        irrigation_rotation_default: 4,
    },
    {
        id: "6",
        real_name_irrigation: "Furrow",
        type: "furrow",
        on_farm_efficiency_min: 0.55,
        runoff_ratio_irrigation: 0.7,
        min_applied_water: 25,
        max_applied_water: 120,
        irrigation_criterium_min: 0.1,
        irrigation_default: 40,
        desirable_storage: 0.85,
        irrigation_rotation_default: 4,
    },
    {
        id: "7",
        real_name_irrigation: "Basin",
        type: "basin",
        on_farm_efficiency_min: 0.65,
        runoff_ratio_irrigation: 1,
        min_applied_water: 30,
        max_applied_water: 120,
        irrigation_criterium_min: 0.1,
        irrigation_default: 40,
        desirable_storage: 0.85,
        irrigation_rotation_default: 4,
    },
    {
        id: "8",
        real_name_irrigation: "Border",
        type: "border",
        on_farm_efficiency_min: 0.45,
        runoff_ratio_irrigation: 0.7,
        min_applied_water: 25,
        max_applied_water: 120,
        irrigation_criterium_min: 0.1,
        irrigation_default: 40,
        desirable_storage: 0.85,
        irrigation_rotation_default: 4,
    },
    {
        id: "9",
        real_name_irrigation: "Micro-Sprinklers",
        type: "micro_sprinklers",
        on_farm_efficiency_min: 0.8,
        runoff_ratio_irrigation: 0.95,
        min_applied_water: 2,
        max_applied_water: 15,
        irrigation_criterium_min: 0.1,
        irrigation_default: 25,
        desirable_storage: 0.4,
        irrigation_rotation_default: 1,
    },
    {
        id: "10",
        real_name_irrigation: "No Irrigation",
        type: "no_irrigation",
        on_farm_efficiency_min: 0,
        runoff_ratio_irrigation: 1,
        min_applied_water: 0,
        max_applied_water: 0,
        irrigation_criterium_min: 0,
        irrigation_default: 0,
        desirable_storage: 0,
        irrigation_rotation_default: 1,
    },
    {
        id: "11",
        real_name_irrigation: "Non-Irrigated",
        type: "non_irrigated",
        on_farm_efficiency_min: 0.9,
        runoff_ratio_irrigation: 0.99,
        min_applied_water: 1,
        max_applied_water: 14,
        irrigation_criterium_min: 0.1,
        irrigation_default: 20,
        desirable_storage: 0.3,
        irrigation_rotation_default: 1,
    },
    {
        id: "12",
        real_name_irrigation: "Dragon-Line",
        type: "dragon_line",
        on_farm_efficiency_min: 0.92,
        runoff_ratio_irrigation: 0.85,
        min_applied_water: 4,
        max_applied_water: 8,
        irrigation_criterium_min: 0.1,
        irrigation_default: 25,
        desirable_storage: 0.3,
        irrigation_rotation_default: 1,
    },
    {
        id: "13",
        real_name_irrigation: "Linear Move",
        type: "linear_move",
        on_farm_efficiency_min: 0.8,
        runoff_ratio_irrigation: 0.85,
        min_applied_water: 2,
        max_applied_water: 20,
        irrigation_criterium_min: 0.1,
        irrigation_default: 25,
        desirable_storage: 0.35,
        irrigation_rotation_default: 1,
    },
];

export const getIrrigationDefaultValue = (type: number, key: IrrigationDataKeys) => {
    const foundConfig = irrigationDefaults.find((val) => val.type === IRRIGATIONS[type]?.i18nKey);
    return foundConfig ? foundConfig[key] : undefined;
};
